<div #verticalMenu class="px-3 pb-2 bg-color_white"
  [ngClass]="{'sidebar-menu': !isMobileSize, 'panel-menu': isMobileSize}">
  <!-- <vertical-menu [tree]="model" class="sth"></vertical-menu> -->
  <div class="d-flex flex-column py-1">
    <div class="d-flex align-items-center py-3"
      [ngClass]="{'flex-column': !isMobileSize, 'justify-content-between w-100': isMobileSize}">
      <div class="avatar p-2">


        <img [imageDirective]="{
          src : 'assets/img/profile.svg'
        }">
      </div>
      <div class="d-flex flex-column align-items-start w-100">
        @if((userData | async)?.baseUser?.realPerson?.firstName && (userData|async)?.baseUser?.realPerson?.lastName){
        <div class="d-flex flex-row justify-content-between align-items-center w-100">
          <span class="font-M1-lg font-M1-md font-M1-sm regular gray_12">
            {{(userData|async)?.baseUser?.realPerson?.firstName + " " +
            (userData|async)?.baseUser?.realPerson?.lastName}}
          </span>
          <i class="isax icon-security-user alarm_6"></i>
        </div>
        }
        @if((userData|async)?.baseUser?.realPerson?.mobileNumber){
        <span class="font-S-lg font-S-md font-S-sm regular gray_8 ">
          {{(userData|async)?.baseUser?.realPerson?.mobileNumber}}
        </span>
        }
      </div>
    </div>
  </div>
  <div class="px-3">
    <hr>
  </div>
  <p-panelMenu [model]="model">
    <ng-template #item let-item>
      <a RouteNavigate [subRoute]="item?.routerLink" [routerLinkActive]="'active'"
        [routerLinkActiveOptions]="item.routerLinkActiveOptions || { exact: false }" [param$]="item.param$"
        [inNewTab]="item.inNewTab" [attr.aria-expanded]="item.expanded"
        (changeVisiblity)="updateMenuVisibility(item, $event)"
        [ngClass]="{'d-none': !item.isVisible && item.parent, 'd-block': item.isVisible && item.parent}" class="p-1">
        <div class="d-flex align-items-center justify-content-between py-2">
          <div class="d-flex align-items-center gap-1">
            <span [class]="item.icon"></span>
            <span class="me-2" [attr.cy-label]="item.label"
              [attr.cy-item-activity]="item.expanded ? item.expanded : false">
              {{ item.label }}
            </span>
          </div>
          <div class="d-flex flex-row align-items-center gap-2 px-1 align-items-center">
            @if (item?.badge) {
            <p-badge [attr.cy-content]="item?.badge" [value]="item.badge" severity="danger" />
            }
            @if (item?.items?.length) {
            <i class="isax" [ngClass]="item?.expanded ? 'icon-arrow-up-2' : 'icon-arrow-down-1'"></i>
            } @else if (isMobileSize) {
            <i class="isax icon-arrow-left-2"></i>
            }
          </div>
        </div>
      </a>
    </ng-template>
  </p-panelMenu>
</div>